// extracted by mini-css-extract-plugin
export default {"event-content":"EventDetail_event-content__lJfCy"};